export enum CountryId {
    Tunisia = 91,
    Russia = 76,
    Abkhazia = 1,
    Uae = 68,
}